var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',[_c('sidebar-links',{class:_vm.$style.sidebar_body,attrs:{"slot":"body","items":_vm.links,"has-close-feature":true,"versions":_vm.versions},on:{"click":_vm.onClickItem},slot:"body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }